export class Guideline {
    constructor() {
        this.id = null;

        this.created_at = null;

        /* Section 1: Base data */
        this.name = null;
        this.submitter_name = null;
        this.type = null;
        this.upload_id = 0;
        this.phase = 0;
        this.conflict_of_interest = 0;

        /* Eanm only | All journalist */
        this.kind_of_work = null;
        this.kind_of_work_joint_description = null;

        this.abbreviation_of_committee = null;


        /* Section 2: Definition of involved parties */

        this.co_author = null;
        this.co_co_author = {};
        this.co_authors = [];
        this.ex_co_authors = [];
        this.review_user_ids = [];

        /* Section 3: Guideline-specific information */

        /* Description */
        this.description = null;
        /* changes made after draft submission to GPC*/
        this.changes = null;

        /* Section 4: Publication */

        /* Destination of publication */
        this.publication = null;
        this.publication_description = null;
        this.publication_target_other_journal = null;
        this.publication_target_other_journal_publisher = null;

        this.journals = 0;

        /* Section 5: Budget */
        this.budget = [];

        /* Section 6: Conditions */
        this.terms_conditions = false;
        this.co_agreement = false;
        this.publication_rules = false;
        this.publication_manuals = false;
        this.necessary_contacts = false;
        this.min_requirements = false;
        this.eanm_title = false;

        this.send_coi_email = false
    }
}

export class Milestone {
    constructor(type) {
        this.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.title = '';
        this.user_id = null;
        this.start = null;

        if (this.types().indexOf(type) !== -1) {
            this.type = type;
        }

        this.color = '#137eff';

        this._rowVariant = null;
        this.delete = null;
    }

    types() {
        return [
            'meeting',
            'meta',
            'medical',
            'publication'
        ];
    }

    colors() {
        return [
            '#137eff',
            '#7e8d9a',
            '#5bc146',
            '#fe0e2a',
        ];
    }
}

export class CoAuthor {
    constructor() {
        this.first_name = null;
        this.last_name = null;
        this.gender = 0;
        this.email = null;
        this.hospital = null;
        this.city = null;
        this.country = null;
        this.co_author = true;
    }
}

const PHASE_DRAFT = 0;                              // Submitter
const PHASE_SUBMITTED = 10;                         // Guidelines and Publications Council  // M1
// Phase 20 has been removed in issue #19
const PHASE_REJECTED = 20;                          // Submitter / Guidelines and Publications Council
const PHASE_FORMAL_CHECK_APPROVAL = 30;              // Submitter
const PHASE_PRE_APPROVED = 40;                      // Submitter  // if exists duplicate and [0] = M2, [1] = M3
const PHASE_UPLOADED_FOR_GPC_REVIEW = 42;           // To GPC
const PHASE_UPLOAD_GPC_REVIEWED = 44;               // Back to Submitter
const PHASE_UPLOAD_GPC_REVIEW_END = 46;             // To Office
const PHASE_UPLOADED_FOR_REVIEW = 50;               // To Reviewer  // M4 || M6 if previous
const PHASE_PARALLEL_REVIEW = 52;                   // To Reviewer + National Delegates (simultaneous)
const PHASE_PARALLEL_REVIEWED = 54;                 // Back to Submitter (re-upload after parallel changes)
const PHASE_PARALLEL_REVIEW_END = 56;               // To Office (parallel review decision)
const PHASE_UPLOAD_REVIEWED = 60;                   // Back to Submitter // M5
const PHASE_UPLOAD_REVIEW_END = 70;                 // To Guidelines and Publications Council  // M7 || M5 if exists in rest
const PHASE_REVIEW_BY_NATIONAL_DELEGATES = 80;      // To National Delegates // M8
const PHASE_REVIEWED_BY_NATIONAL_DELEGATES = 90;    // To Submitter 
const PHASE_REVIEW_BY_NATIONAL_DELEGATES_END = 100; // To Submitter // M9
const PHASE_GPC_FINAL_APPROVAL = 102;               // To GPC
const PHASE_GPC_FINAL_HOLD = 104;                   // To Submitter
const PHASE_BOARD_APPROVAL = 110;                   // To Office  // M10
const PHASE_BOARD_APPROVAL_APPROVED = 120;          // To Office // M11
const PHASE_BOARD_APPROVAL_ON_HOLD = 130;           // To Office
const PHASE_FINAL_PUBLISHED = 140;                  // To Office // M12

export class GuidelinePhases {
    static get draft() {return PHASE_DRAFT}
    static get submitted() {return PHASE_SUBMITTED}
    static get rejected() {return PHASE_REJECTED}
    static get formalCheckApproval() {return PHASE_FORMAL_CHECK_APPROVAL}
    static get preApproved() {return PHASE_PRE_APPROVED}
    static get uploadedForGpcReview() {return PHASE_UPLOADED_FOR_GPC_REVIEW}
    static get uploadGpcReviewed() {return PHASE_UPLOAD_GPC_REVIEWED}
    static get uploadGpcReviewedEnd() {return PHASE_UPLOAD_GPC_REVIEW_END}
    static get uploadedForReview() {return PHASE_UPLOADED_FOR_REVIEW}
    static get parallelReview() {return PHASE_PARALLEL_REVIEW}
    static get parallelReviewed() {return PHASE_PARALLEL_REVIEWED}
    static get parallelReviewEnd() {return PHASE_PARALLEL_REVIEW_END}
    static get uploadReviewed() {return PHASE_UPLOAD_REVIEWED}
    static get uploadReviewedEnd() {return PHASE_UPLOAD_REVIEW_END}
    static get reviewByNationalDelegates() {return PHASE_REVIEW_BY_NATIONAL_DELEGATES}
    static get reviewedByNationalDelegates() {return PHASE_REVIEWED_BY_NATIONAL_DELEGATES}
    static get reviewByNationalDelegatesEnd() {return PHASE_REVIEW_BY_NATIONAL_DELEGATES_END}
    static get gpcFinalApproval() {return PHASE_GPC_FINAL_APPROVAL}
    static get gpcFinalHold() {return PHASE_GPC_FINAL_HOLD}
    static get boardApproval() {return PHASE_BOARD_APPROVAL}
    static get boardApprovalApproved() {return PHASE_BOARD_APPROVAL_APPROVED}
    static get boardApprovalOnHold() {return PHASE_BOARD_APPROVAL_ON_HOLD}
    static get finalPublish() {return PHASE_FINAL_PUBLISHED}
}

const ROLE_COAUTHOR = 1;
const ROLE_COCOAUTHOR = 2;
const ROLE_REVIEWER = 3;

export class GuidelineUserRoles {
    static get coauthor() {return ROLE_COAUTHOR}
    static get cocoauthor() {return ROLE_COCOAUTHOR}
    static get reviewer() {return ROLE_REVIEWER}
}

export class GuidelineUserRolesStatus {
    static get unconfirmed() {return 0}
    static get accepted() {return 1}
    static get rejected() {return 2}
    static get changeRequest() {return 3}
}
